import { I18n } from 'react-redux-i18n';
import { NewTableHeaderAction, NewTableHeaderPredefinedActionType } from '../new-table.types';

export const processHeaderActions = (params: {
  headerActions: Array<NewTableHeaderAction>;
  openFieldSelector: () => void;
}) => {
  const { headerActions, openFieldSelector } = params;
  const predefinedActionsConfig: Record<NewTableHeaderPredefinedActionType, { config: NewTableHeaderAction }> = {
    [NewTableHeaderPredefinedActionType.addColumn]: { 
      config: { label: I18n.t('Add Column'), onClick: openFieldSelector },
    },
  };
  
  const processedHeaderActions: Array<NewTableHeaderAction> = [];
  
  headerActions.forEach(({ type, ...otherProps }) => {
    if (type && predefinedActionsConfig[type]) {
      const config = {
        ...predefinedActionsConfig[type].config,
        ...otherProps,
      };

      processedHeaderActions.push(config);

      return;
    }

    processedHeaderActions.push({
      ...otherProps,
      onClick: otherProps.onClick
    });
  });

  return processedHeaderActions;
};